import React from 'react';

const WinterSports = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='14.004'
            viewBox='0 0 14 14.004'
            className={className}
        >
            <g id='Winter_Sports' data-name='Winter Sports' transform='translate(-55.995 -507.806)'>
                <path
                    id='Path_3136'
                    data-name='Path 3136'
                    d='M61.165,511a1.708,1.708,0,0,0-.026,2.256,5.652,5.652,0,0,0,1.752,1.366.727.727,0,0,1,.28,1.08l-.013.019c-.461.611-.971,1.152-.971,1.152l-5.3-3.012a.594.594,0,0,0-.8.2h0a.591.591,0,0,0,.2.828l10.525,6.071a2.4,2.4,0,0,0,2.981-.463l.047-.051a.581.581,0,0,0-.146-.9h0a.585.585,0,0,0-.746.147l-.028.035a1.123,1.123,0,0,1-1.455.271l-4.311-2.576,2.085-1.538a1.476,1.476,0,0,0-.273-2.142Z'
                    transform='translate(0 0.532)'
                />
                <path
                    id='Path_3137'
                    data-name='Path 3137'
                    d='M58.852,509.87l.007.006a.482.482,0,0,0,.557,0l.093-.064a.212.212,0,0,1,.249,0l3.163,2.325a.991.991,0,0,0,.937.128l.345-.13a.167.167,0,0,1,.226.168l-.051.775a.617.617,0,0,0,.337.59l2.581,1.313a.5.5,0,0,0,.635-.166h0a.491.491,0,0,0-.144-.684l-1.912-1.234a.283.283,0,0,1-.117-.323l.455-1.44a1.409,1.409,0,0,0-1.377-1.832h0a5.76,5.76,0,0,0-3.267,1.1h0l-1.379-1.042a.21.21,0,0,1-.066-.251l.089-.2a.472.472,0,0,0-.211-.606l-.007,0a.255.255,0,0,0-.347.1c-.057.106-.16.209-.205.292a.134.134,0,0,1-.162.062L58.8,508.6a.049.049,0,0,0-.056.075l.26.37a.134.134,0,0,1,0,.151l-.219.336A.251.251,0,0,0,58.852,509.87Z'
                    transform='translate(0.457 0.078)'
                />
                <circle
                    id='Ellipse_20'
                    data-name='Ellipse 20'
                    cx='1.278'
                    cy='1.278'
                    r='1.278'
                    transform='translate(66.654 507.806)'
                />
            </g>
        </svg>
    );
};

export default WinterSports;
